import { GetURLParams } from '@buyhatke/custom-lib-js';

import {
	checkDocument,
	getWSLSKey,
	setWSLSKey,
	Harpic,
} from '@utils/customLib';
import {
	countriesList,
	languageList,
	currenciesList,
	getCountryFromCode,
	getCountryProperty,
	getCurrencyFromCode,
	getCountryProps,
} from '@utils/params';

import { isLoggedIn, logoutMaadi } from '@utils/cred';

const __selectCountry = (_, selectedCountry) => {
	const lowerSelectedCountry = selectedCountry.toLowerCase();

	if (checkDocument) {
		window.localStorage.setItem('selectedCountry', lowerSelectedCountry);
	}

	return {
		selectedCountry: lowerSelectedCountry,
	};
};

const __setInitialCurrency = ctry => {
	if (checkDocument) {
		const selectedCurrency = Harpic(
			window.localStorage.getItem('selectedCurrency')
		);

		if (selectedCurrency && currenciesList.indexOf(selectedCurrency) > -1) {
			return { selectedCurrency };
		}
	}

	//  if currency is not set already, then set based on user's Country
	return {
		selectedCurrency:
			getCurrencyFromCode(getCountryProperty(ctry, 'currCode')) || 'inr',
	};
};

const __setInitialLanguage = ctry => {
	if (checkDocument) {
		const selectedLanguage = Harpic(
			window.localStorage.getItem('selectedLanguage')
		);

		if (
			selectedLanguage &&
			languageList[selectedLanguage]?.code === selectedLanguage
		) {
			return { selectedLanguage };
		}
	}

	//  if Language is not set already, then set based on user's Country
	return {
		selectedLanguage: getCountryProps(ctry)?.languageCode || 'en',
	};
};

const getInitialCountry = () => {
	const selectedCountry =
		checkDocument && Harpic(window.localStorage.getItem('selectedCountry'));

	if (selectedCountry && countriesList.indexOf(selectedCountry) > -1) {
		return selectedCountry;
	}

	return GetURLParams('country') || 'in';
};

export const initialLoginState = {
	isLoggedIn: +getWSLSKey('bb-isLoggedIn') || 0,
	phone_verified: 0,
	process_done: 0,
	checkingLogin: -1,
	video_kyc: 0,
};

const checkLogin = async isLoggedInfromState => {
	try {
		const { status, country, phone_verified, process_done, video_kyc } =
			await isLoggedIn();
		const ctry =
			status === 1 ? getCountryFromCode(country) : getInitialCountry();

		const hasLoggedInChanged = isLoggedInfromState !== status;

		if (hasLoggedInChanged) {
			setWSLSKey('bb-isLoggedIn', status);
		}

		return {
			...(hasLoggedInChanged && {
				isLoggedIn: status,
			}),
			phone_verified,
			process_done,
			video_kyc,
			...__selectCountry(undefined, ctry),
			checkingLogin: false,
			...__setInitialCurrency(ctry),
			...__setInitialLanguage(ctry),
		};
	} catch (error) {
		console.log('isLoggedin', error);
	}

	return {};
};

const logout = async () => {
	try {
		const { status } = await logoutMaadi();

		if (status === 1) {
			if (checkDocument) {
				const { informvisitors } = window;

				if (informvisitors) {
					try {
						const mappedUId = informvisitors.getMappedUID();

						if (mappedUId) {
							// console.log('IV: has existing uid, so unmapping');
							informvisitors.unmapDevID();
						}
					} catch (error) {
						console.log('IV: unmapDevID', error);
					}
				}
			}
			// update the loggedIn state to LS
			setWSLSKey('bb-isLoggedIn', 0);

			return {
				isLoggedIn: 0,
				phone_verified: 0,
				process_done: 0,
				video_kyc: 0,
			};
		}
	} catch (error) {
		console.log('logout', error);
	}

	return {
		checkingLogin: false,
	};
};

// ------------------------------------------------------------

export const loginActions = ({ action, setState }) => ({
	__checkLogin: ({ checkingLogin, isLoggedIn: isLoggedInfromState }) => {
		if (checkingLogin !== true) {
			setState({
				checkingLogin: true,
			});
			action(checkLogin)(isLoggedInfromState);
		}
		return {};
	},
	__logOut: logout,
});
